export default __webpack_public_path__ + "static/media/ToDoListApp.f639035d.gif";